import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';

import { ApCookieConsentService } from '@ap/cookie-consent';
import { MijnAnalyseModule } from '@ap/mijn-analyse';
import { ApPersistenceService } from '@ap/persistence';

/**
 * @module MijnLoginModule
 * @ngdoc component
 * @name MijnLoginComponent
 */
@Component({
    selector: 'mijn-login',
    templateUrl: 'mijn-login.component.html',
    imports: [MijnAnalyseModule, RouterOutlet]
})
export class MijnLoginComponent implements OnInit, AfterViewInit {
    private readonly CACHE_KEY = 'mijn-cache';

    public constructor(
        private readonly cookieConsentService: ApCookieConsentService,
        private readonly persistenceService: ApPersistenceService,
        private readonly router: Router
    ) {}

    public ngOnInit(): void {
        // with usehash false the orgurls with a hash wil possible fail after login unless we redirect them using the snippet below
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                let eventUrl = event.url;
                eventUrl = eventUrl.replace('%2F#', '/#');
                if (!!eventUrl && eventUrl.match(/^\/#/)) {
                    if (eventUrl.match(/^.+\/$/)) {
                        eventUrl = eventUrl.substring(0, eventUrl.length - 1);
                    }
                    eventUrl = eventUrl.replace(/\/#/g, '');
                    eventUrl = this.encodeOrgUrl(eventUrl);
                    this.router.navigateByUrl(eventUrl);
                    return;
                }
            }
        });
        this.persistenceService.clearSession(this.CACHE_KEY);
        this.persistenceService.setLocal('ap-sign', 'digipas', undefined);
        this.persistenceService.setLocal('ap-sign', 'digicode-username', undefined);
        this.persistenceService.setSession('mijn-login', 'context', undefined);
    }

    public ngAfterViewInit(): void {
        const consentLevels = this.cookieConsentService.getConsent();
        if (consentLevels.empty) {
            this.cookieConsentService.setLayout('small');
            this.cookieConsentService.open();
        }
    }

    private encodeOrgUrl(url: string): string {
        const ORGURL = '?orgurl=';
        const splitUrl = url.split(ORGURL);
        if (splitUrl[1]) {
            return splitUrl[0] + ORGURL + encodeURIComponent(splitUrl[1]);
        }
        return url;
    }
}
